
import React from 'react';
import { cn } from '@/lib/utils';

type BookInfoProps = {
  title: string;
  description: string;
  image: string;
  ctaText?: string;
  ctaLink?: string;
};

const BookInfo = ({ title, description, image, ctaText = "Get the Book", ctaLink = "#" }: BookInfoProps) => {
  return (
    <section className="py-16 bg-neutral-tan">
      <div className="container mx-auto px-4">
        <div className="flex flex-col md:flex-row items-center gap-8 max-w-4xl mx-auto">
          <div className="w-full md:w-1/3">
            <div className="vintage-card h-full transform rotate-[-2deg] shadow-premium hover:rotate-0 transition-all duration-300">
              {/* Direct image element that can be edited */}
              <img 
                src="/lovable-uploads/1ac54ac2-9cca-4e0d-9e41-95d9e9b92bf9.png" 
                alt={`Book cover: ${title}`} 
                className="w-full h-auto rounded shadow-lg"
              />
            </div>
          </div>
          <div className="w-full md:w-2/3">
            <h3 className="text-2xl md:text-3xl font-playfair font-bold mb-4">
              {title}
            </h3>
            <div className="text-lg mb-6 space-y-4 font-lora text-text/90">
              {description.split('\n').map((paragraph, index) => (
                <p key={index}>{paragraph}</p>
              ))}
            </div>
            <a 
              href={ctaLink} 
              target="_blank" 
              rel="noopener noreferrer"
              className="btn-accent"
            >
              {ctaText}
            </a>
          </div>
        </div>
      </div>
    </section>
  );
};

export default BookInfo;
